export default __webpack_public_path__ + "static/media/kfurigana.004a6426.png";